// extracted by mini-css-extract-plugin
export default {"gallery":"styles_gallery__2L8lQ"};